import apiClient from '../clienteFebosAPI';

const RESOURCE = '/gestionpresupuesto';

export const getCentroCostos = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.get(`${RESOURCE}/centrocosto?${params}`, { operacionId: 'cl.list.centrocostos' });
};
